import React, { useState, useEffect, useContext } from 'react';
import UserContext from '../../components/User_Context.js';
import * as menu from "../../assets/menus/menu.js"
import { Organizational_Chart } from "../../components/ui/organizational_chart.js";
import * as breadcrumb from "../../components/ui/breadcrumb.js";
import * as api from "../../api/apiConnector.js";
import waiting from "../../assets/images/waiting.svg";
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import * as utils from "../../components/utils.js";
import Undo_Redo from "../../components/ui/undo_redo.js";
import Choices from '../../components/Choices.js';
import { useTranslation } from 'react-i18next';

const Requirements_Screen = (params) => {
    const { currentUser } = useContext(UserContext);
    const [data, setData] = useState(null);
    const [types, setTypes] = useState(null);
    const [userUnits, setUserUnits] = useState(null);
    const [currentNode, setCurrentNode] = useState(null);
    const [draggingNode, setDraggingNode] = useState(null);
    const [droppingNode, setDroppingNode] = useState(null);
    const [viewMode, setViewMode] = useState("list");

    const { t } = useTranslation();
    const levelLabels = [
        'Point of attention',
        'Aspect to be considered'
    ];

    const [preventQuit, setPreventQuit] = useState(false);
    let undo_redo = null;

    const _drawTabs = () => {
        for (let t of types) {
            for (let b of t.BusinessUnits) {
                for (var f of b.Flows) {
                    f.level = 0;
                    let _current = f;
                    while (_current) {
                        f.level++;
                        _current = b.Flows.find(x => x.Requirement.Id == _current.Requirement.ParentId);
                    }
                }
            }
        }

        if (types.length > 0) types[0].selected = true;

        const _drawTabHeader = (t) => {
            return (<li className="nav-item" role="presentation">
                <button className={`nav-link ${t.selected ? "active" : ""}`} id={`main-tab-${t.Code}`} data-bs-toggle="tab" data-bs-target={`#tab-content-${t.Code}`} type="button" role="tab" aria-controls={`#tab-content-${t.Code}`}
                    aria-selected={t.selected ? true : null}>{t.Name}</button>
            </li>);
        }

        const _drawTabDiv = (t) => {
            const _businessUnit = t.BusinessUnits.find(x => x.selected);
            const _rootNodes = _businessUnit ? _businessUnit.Flows.filter(x => x.level == 1)
                .sort((a, b) => { return a.Requirement.ItemOrder - b.Requirement.ItemOrder }) : [];

            const _countChildren = (f) => {
                const _children = _businessUnit.Flows.filter(x => x.Requirement.ParentId == f.Requirement.Id);
                f._childrenCount = _children.length;
                for (const c of _children) {
                    f._childrenCount += _countChildren(c);
                }

                return f._childrenCount;
            }

            const _countMaxLevel = (f, level) => {
                const _children = _businessUnit.Flows.filter(x => x.Requirement.ParentId == f.Requirement.Id);
                f._childrenMaxLevel = level || 1;
                f._level = level || 1;
                for (const c of _children) {
                    const _childMaxLevel = _countMaxLevel(c, (level || 1) + 1);

                    if (_childMaxLevel > f._childrenMaxLevel) {
                        f._childrenMaxLevel = _childMaxLevel;
                    };
                }

                return f._childrenMaxLevel;
            }

            if (_businessUnit) {
                for (const f of _businessUnit.Flows) {
                    _countChildren(f);

                }
            }

            const _businessUnitSelector = () => {
                if (t.BusinessUnits.length > 1) {
                    return (<select data-mode="business_unit_selector" onChange={(e) => {
                        const _selectedValue = window.$(e.target).val();
                        for (var b of t.BusinessUnits) {
                            t.selected = t.Id == _selectedValue;
                        }
                        setTypes(utils.clone(types));
                    }}>
                        {t.BusinessUnits.map((b) => {
                            return (<option value={b.Id} selected={b.selected}>{b.Name}</option>);
                        })}
                    </select>);
                }
                else {
                    if (t.BusinessUnits.length == 1) {
                        return (<h6>{t.BusinessUnits[0].Code} {t.BusinessUnits[0].Name}</h6>)
                    }
                }
            }

            const _drawTable = (node) => {
                const _getChildNodes = (n) => {
                    const output = [n];
                    const _children = _businessUnit.Flows.filter(x => x.Requirement.ParentId == n.Requirement.Id);
                    for (const c of _children) {
                        output.push(..._getChildNodes(c));
                    }

                    return output;
                }

                const _nodeData = _getChildNodes(node);

                let _data = _nodeData.filter(x => x._level == node._childrenMaxLevel);

                for (const d of _data) {
                    let _current = d;
                    while (_current) {
                        if (_current.Requirement.ParentId) {
                            _current.parent = _nodeData.find(x => x.Requirement.Id == _current.Requirement.ParentId);
                            _current = _current.parent;
                        }
                        else {
                            _current = null;
                        }
                    }
                }

                for (const d of _data) {
                    d._uiOrder = 0;
                    let _current = d;
                    let _level = 0;
                    while (_current) {
                        d._uiOrder += _current.Requirement.ItemOrder * Math.pow(10, _level);
                        _current = _current.parent;
                        _level++;
                    }
                }

                _data = _data.sort((a, b) => { return a._uiOrder - b._uiOrder });

                const _drawTr = (r) => {
                    const _cells = [];
                    const _getLevel = (node, l) => {
                        if (node._level > l) {
                            return _getLevel(node.parent, l);
                        }
                        else {
                            return node;
                        }
                    }

                    for (let level = 2; level <= r._level; level++) {
                        if (level == r._level
                            ||
                            _getLevel(r, level + 1).Requirement.ItemOrder == 0
                        ) {
                            const _node = _getLevel(r, level);
                            _cells.push(<td rowSpan={_node._childrenCount > 0 ? _node._childrenCount : 1} style={{ whiteSpace: "wrap" }} >
                                {level == r.level ? (<><a href={`/requirements/evaluation/${_node.Requirement.Id}`}>
                                    <i class="fa fa-pen-to-square"></i></a></>) : (null)}
                                <strong>{_node.Requirement.Code}</strong> {_node.Requirement.Name}</td>);
                            if (level == r._level) {
                            }
                        }
                    }

                    return (<tr>{_cells}</tr>)
                }

                const _drawHader = () => {
                    const _levels = [];
                    for (let i = 2; i <= node._childrenMaxLevel; i++) {
                        _levels.push(`${levelLabels[i - 2]}`);
                    }
                    //_levels.push("Notes");

                    return (<tr>
                        {_levels.map((l) => {
                            return (<th>{l}</th>)
                        })}
                    </tr>);
                }
                return (
                    <table className="table">
                        <thead>
                            {_drawHader()}
                        </thead>
                        <tbody>
                            {_data.map((r) => {
                                return _drawTr(r);
                            })}
                        </tbody>
                    </table>);
            }

            const _drawRootNode = (node, subLevel) => {
                _countMaxLevel(node);

                const _getTitle = () => {
                    if (subLevel == 1) {
                        return (<h6 className="accordion-header">
                            <button aria-expanded="false" data-bs-target={`#node_div_${node.Id}`} className="accordion-button collapsed" type="button" data-bs-toggle="collapse">
                                {node.Requirement.Code} {node.Requirement.Name}
                            </button>
                        </h6>);
                    }
                    else {
                        <h6>{node.Requirement.Code} {node.Requirement.Name}</h6>
                    }
                }

                return (<div className={subLevel == 1 ? "accordion-item" : null} data-bs-parent="accordion">
                    {_getTitle()}
                    <div id={`node_div_${node.Id}`} className={subLevel == 1 ? "accordion-collapse collapse" : null}>
                        <div className="small container">
                            {node.Requirement.Description}
                            <hr></hr>
                        </div>
                        {
                            (node._childrenMaxLevel == 3) ? (_drawTable(node)) : (<>
                                {_businessUnit.Flows.filter(x => x.Requirement.ParentId == node.Requirement.Id)
                                    .sort((a, b) => { return a.Requirement.ItemOrder - b.Requirement.ItemOrder })
                                    .map(x => _drawRootNode(x, subLevel + 1))
                                }
                            </>)
                        }
                    </div>

                </div>);
            }

            return (<div className={`tab-pane fade active ${t.selected ? "show" : ""}`} id={`tab-content-${t.Code}`} role="tabpanel" aria-labelledby={`#tab-content`}>
                <p class="lead">
                    {_businessUnitSelector()}
                </p>
                <div class="accordion">
                    {_rootNodes

                        .map((r) => {
                            return _drawRootNode(r, 1);
                        })}
                </div>
            </div>);
        }

        return (
            <><ul class="nav nav-tabs" id="classification-tabs" role="tablist">
                {types.map((t) => { return _drawTabHeader(t) })}
            </ul>
                <div class="tab-content" id="tabs-cmagari ontent" style={{ padding: 15 }}>
                    {types.map((t) => { return _drawTabDiv(t) })}
                </div>
            </>)
    }
    //endregion

    //#region editing
    const _update = () => {
        setData(utils.clone(_renumber(data)));
    
        if (undo_redo) {
            undo_redo.push(data);
            setPreventQuit(true);
        }
    }

    const _renumber = (nodes, node, level) => {
        const _children = nodes.filter(x => x.ParentId == node?.Id && !x.Deleted)
            .sort((a, b) => { return a.ItemOrder - b.ItemOrder });

        for (var i = 0; i < _children.length; i++) {
            const _child = _children[i];
            if (_child.ItemOrder != i) {
                _child.ItemOrder = i;
                _child.__toUpdate = true;
            }
        }

        for (var c of _children) {
            _renumber(nodes, c, (level ?? 0) + 1);
        }

        return nodes;
    }

    const editModal = () => {
        const _validate = () => {
            if (!currentNode.Name) return false;
            return true;
        }

        const _localUpdate = () => {
            currentNode.__localUpdate = true;
            setCurrentNode(utils.clone(currentNode));
        }

        const _confirmEdit = () => {
            const _indexToUpdate = data.findIndex(x => x.Id == currentNode.Id);
            currentNode.__toUpdate = true;
            currentNode.__localUpdate = false;
            data[_indexToUpdate] = currentNode;
            _update();
            setCurrentNode(null);
        }


        if (currentNode) {
            return (
                <>
                    <div class="modal-backdrop fade show"></div>
                    <div id="requisite_edit_modal" className="modal fade show" style={{ display: "block" }} >
                        <div className="modal-dialog modal-xl  modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">{currentNode.Name}</h5>
                                    <button type="button" className="btn-close" aria-label="Close"
                                        onClick={(e) => {
                                            setCurrentNode(null);
                                        }}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <div>
                                        <label for="item_code" className="form-label"> {t('code', { ns: 'labels' })}</label>


                                        <input id="item_code" type="text" className="form-control" value={currentNode.Code}
                                            onChange={(e) => {
                                                currentNode.Code = e.target.value;
                                                _localUpdate();
                                            }}
                                            placeholder={t('codeOfItem', { ns: 'labels' })} />

                                    </div>
                                    <br></br>
                                    <div>
                                        <label for="item_name" className="form-label">{t('name', { ns: 'labels' })}<span className="text-danger">*</span></label>

                                        <textarea rows="3" id="item_name" type="text" className="form-control" value={currentNode.Name}
                                            onChange={(e) => {
                                                currentNode.Name = e.target.value;
                                                _localUpdate();
                                            }}
                                            placeholder={t('nameOfItem', { ns: 'labels' })}></textarea>

                                    </div>
                                    <br></br>
                                    <div className='d-flex'>
                                        <label for="item_name" className="form-label">{t('classification', { ns: 'labels' })}<span className="text-danger">*</span></label>

                                        {<Choices voc={types}
                                            dropDownParent={"requisite_edit_modal"}
                                            value={"Code"} text={"Name"}
                                            selected={currentNode.RequirementContextCode ? [types.find(x => x.Code == currentNode.RequirementContextCode)] : []}
                                            onChange={(e) => {
                                                currentNode.RequirementContextCode = e.selected &&
                                                    e.selected.length > 0 ? e.selected[0].Code : null;
                                                _localUpdate();
                                            }
                                            }></Choices>}

                                    </div>
                                    <br></br>
                                    <div>
                                        <label for="item_description" className="form-label">{t('description', { ns: 'labels' })}</label>
                                        <textarea id="item_description" rows="5" className="form-control" value={currentNode.Description}
                                            onChange={(e) => {
                                                currentNode.Description = e.target.value;
                                                _localUpdate();
                                            }}
                                            placeholder={t('descriptionOfItem', { ns: 'labels' })}>

                                        </textarea>
                                    </div>
                                    <br></br>
                                    <div>
                                        <label for="item_notes" className="form-label">{t('notes', { ns: 'labels' })}</label>
                                        <textarea id="item_notes" rows="5" className="form-control" value={currentNode.Notes}
                                            onChange={(e) => {
                                                currentNode.Notes = e.target.value;
                                                _localUpdate();
                                            }}
                                            placeholder={t('notes', { ns: 'labels' })}>

                                        </textarea>
                                    </div>
                                    <br></br>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary"
                                        onClick={(e) => {
                                            setCurrentNode(null);
                                        }}
                                    >{t('close', { ns: 'labels' })}</button>
                                    <button type="button" onClick={(e) => {
                                        _confirmEdit();
                                    }}
                                        className="btn btn-primary" disabled={_validate ? null : true}>{t('ok', { ns: 'labels' })}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )
        }
        else {
            return (null);
        }

    }

    const drawNode = (params) => {
        const { node, level = 0 } = params;

        const children = data.filter(x => x.ParentId == node.Id && !x.Deleted).sort((a, b) => { return a.ItemOrder - b.ItemOrder });
        const brothers = data.filter(x => x.ParentId == node.ParentId && !x.Deleted).sort((a, b) => { return a.ItemOrder - b.ItemOrder });
        const nodeIndex = brothers.findIndex(x => x === node);

        if (node.Deleted) {
            return (null);
        }
        else {
            return (
                <>
                    <tr data-id={node.Id}>
                        <th scope="row" style={{ cursor: "move" }} title={`Move the requirement`}>
                            {node.Code}
                        </th>
                        <td style={{ whiteSpace: "wrap", cursor: "move" }} title={`Drag the requirement "${node.Name}" in a different location or as child of a node`}>
                            {
                                level < 3 ? (<h5 style={{ marginLeft: `${level * 3}em` }}>{node.Name}</h5>) : (
                                    <p style={{ marginLeft: `${level * 3}em` }}>{node.Name}</p>
                                )
                            }
                        </td>

                        <td>
                            <div>

                                <i style={{ cursor: 'pointer' }} data-bs-tooltip="tooltip" data-bs-placement='top' title={`Add new requirement`} onClick={async (e) => {
                                    _addNode(node);
                                }} className="fa-regular fa-square-plus me-4 fa-2x hover-icon-add"

                                />
                                <i style={{ cursor: 'pointer', color: '#17a2b8' }} data-bs-tooltip="tooltip" data-bs-placement='top' onClick={(e) => {
                                    setCurrentNode(utils.clone(node));
                                }} className="fa-regular fa-pen-to-square me-4 fa-2x hover-icon-edit"
                                    title={`Edit the requirement`}
                                />

                                <i style={{ cursor: 'pointer', color: '#dc3545' }} data-bs-tooltip="tooltip" data-bs-placement='top' title="Delete the requirement" onClick={(e) => {
                                    _deleteNode(node.Id);
                                }} className="fa fa-trash fa-2x hover-icon-trash me-4" />

                                {
                                    nodeIndex > 0 ? (<i style={{ cursor: 'pointer' }} data-bs-tooltip="tooltip" data-bs-placement='top' title="move up" onClick={(e) => {
                                        const _tmp = brothers[nodeIndex].ItemOrder;
                                        brothers[nodeIndex].ItemOrder = brothers[nodeIndex - 1].ItemOrder;
                                        brothers[nodeIndex - 1].ItemOrder = _tmp;
                                        brothers[nodeIndex - 1].__toUpdate = true;
                                        _update();
                                    }} className="fa fa-arrow-up fa-2x hover-icon-edit me-4" />) : (null)
                                }

                                {
                                    nodeIndex < brothers.length - 1 ? (<i style={{ cursor: 'pointer' }} data-bs-tooltip="tooltip" data-bs-placement='top' title="move up" onClick={(e) => {
                                        const _tmp = brothers[nodeIndex].ItemOrder;
                                        brothers[nodeIndex].ItemOrder = brothers[nodeIndex + 1].ItemOrder;
                                        brothers[nodeIndex + 1].ItemOrder = _tmp;
                                        brothers[nodeIndex + 1].__toUpdate = _tmp;
                                        _update();
                                    }} className="fa fa-arrow-down fa-2x hover-icon-edit" />) : (null)
                                }
                            </div>
                        </td>
                    </tr>

                    {(children.length > 0) ? (<>
                        {children.map(x => drawNode({ node: x, level: level + 1 }))}
                    </>)
                        : (null)}
                </>
            )
        }

    }

    const _deleteNode = (id, level) => {
        const _node = data.find(x => x.Id == id);
        _node.Deleted = true;
        _node.__toUpdate = true;

        const _children = data.filter(x => x.ParentId == id);
        for (var c of _children) {
            _deleteNode(c.Id, (level || 0) + 1);
        }

        if (!level) {
            _update();
        }
    }

    const _getNewNode = async () => {
        const _node = (await api.sendMessage("admin/system/organization/getNewBusinessUnit", {
            user: currentUser()
        }))?.node;

        return _node;
    }

    const _addNode = async (node) => {
        const _node = await _getNewNode();
        const _childrenOrder = data.filter(x => x.ParentId == node.Id).map(x => x.ItemOrder);
        _node.ParentId = node.Id;
        _node.ItemOrder = _childrenOrder.length > 0 ? Math.max(_childrenOrder) : 0;
        _node.Name = "New requirement";
        _node.__toUpdate = true;
        _node.__localUpdate = false;
        data.push(_node);
        _update();
        setCurrentNode(utils.clone(_node));
    }

    const drawMainNode = () => {
        const levelOneNodes = data.filter(x => (x.ParentId == null) && !x.Deleted)
            .sort((a, b) => { return a.ItemOrder - b.ItemOrder })
            ?? [];
        return (
            <>
                <tr data-root-node="true" >
                    <td></td>
                    <td></td>
                    <td>
                        <div>
                            <i style={{ cursor: 'pointer' }} data-bs-tooltip="tooltip" data-bs-placement='top' title='Add' onClick={(e) => {
                                _addNode({ node: { Id: null } });
                            }} className="fa-regular fa-square-plus me-4 fa-2x hover-icon-add" />
                        </div>
                    </td>
                </tr>

                {(levelOneNodes.length > 0) ? (<>
                    {levelOneNodes.map(x => drawNode({ node: x, level: 1 }))}
                </>)
                    : (null)}
            </>
        )
    }
    //#endregion

    const setBreadCrumb = (params) => {
        var path = [{
            link: "/",
            name: t("menu.main")
        },
        {
            link: "/Requirements",
            name: t("menu.requirements.title")
        }
        ];
        breadcrumb.set(path);
    }


    const retrieveData = async () => {
        const result = (await api.sendMessage("admin/requirements/get_all", {
            user: currentUser(),
        }));

        var types = (await api.sendMessage("admin/vocs/get", {
            user: currentUser(),
            body: {
                voc_id: "requisites_main_contexts"
            }
        }))?.items ?? [];

        if (!result.success) {
            withReactContent(Swal).fire({
                title: t("error", { ns: "labels" }),
                icon: "error",
                text: t("error_message", { ns: "labels" }, { message: result?.message }),
                allowOutsideClick: false
            });
            return;
        }

        const _normalizeRequirement = (node) => {
            const _child = result.requirements.filter(x => x.ParentId == node.Id);
            for (var c of _child) {
                if (c.RequirementContextCode != node.RequirementContextCode) {
                    c.RequirementContextCode = node.RequirementContextCode;
                    c.__toUpdate = true;
                }
                _normalizeRequirement(c);
            }
        }

        for (var r of result.requirements) {
            _normalizeRequirement(r);
        }

        for (var type of types) {
            type.BusinessUnits = result.user_requirements.filter(x => x.Flows.find(x => x.Requirement.RequirementContextCode == type.Code));
            if (type.BusinessUnits.length > 0) {
                type.BusinessUnits[0].selected = true;
            }
        }

        setData(result.requirements);
        setUserUnits(result.user_requirements);
        setTypes(types);
        undo_redo.push(result.requirements);


    }

    useEffect(() => {
        (async () => {
            setBreadCrumb();
            menu.write({ user: currentUser() });
            await retrieveData();
        })();

        

    }, []);


    useEffect(() => {
        if(preventQuit){
            const handleBeforeUnload = (event) => {

                event.preventDefault();
    
                event.returnValue = '';
            };
    
            window.addEventListener('beforeunload', handleBeforeUnload);
    
            return () => {
                window.removeEventListener('beforeunload', handleBeforeUnload);
            };
        }
    }, [preventQuit]);

    useEffect(() => {
        _drawChangeMode();
    }, [viewMode]);

    useEffect(() => {
        window.$("tr[data-id]").draggable({
            opacity: 0.7,
            cursor: "move",
            containement: "table",
            revert: "invalid",
            start: (e) => {
                window.$(e.target).css("z-index", 1000);
                setDraggingNode(data.find(x => x.Id == window.$(e.target).attr("data-id")));
            },
            stop: (e) => {
                window.$(e.target).css("z-index", 0);
                window.$("tr[data-id]").find("td").removeClass("table-primary");
            },
            axis: "y"
        });

        window.$("tr[data-id]").droppable({
            over: (e, ui) => {
                window.$(e.target).find("td").addClass("table-primary");
            },
            out: (e, ui) => {
                window.$(e.target).find("td").removeClass("table-primary");
            },
            drop: (e, ui) => {
                setDroppingNode(data.find(x => x.Id == window.$(e.target).attr("data-id")));
                ui.draggable.animate({ left: 0, top: 0 }, 500);
            }
        });

        window.$("tr[data-root-node]").droppable({
            drop: (e, ui) => {
                setDroppingNode({ Id: null });
                ui.draggable.animate({ left: 0, top: 0 }, 500);
            }
        });

        window.$("select[data-mode='business_unit_selector']").select2();
    }, [data, currentNode, viewMode, types]);

    const _getPath = (node) => {
        const output = [];
        let _current = node;
        while (_current) {
            output.push(_current);
            _current = data.find(x => x.Id == _current.ParentId);
        }

        return output.reverse();
    }

    const _getChildren = (node) => {
        const output = [node];
        const _children = data.filter(x => x.ParentId == node.Id);
        if (_children) {
            for (var c of _children) {
                const _subItems = _getChildren(c);
                output.push(..._subItems);
            }
        }

        return output;
    }

    useEffect(() => {
        if (draggingNode && droppingNode) {
            const _draggingPath = _getPath(draggingNode);
            const _forbidden = _getChildren(draggingNode).find(x => x.Id == droppingNode.Id);
            if (_forbidden) {

            }
            else {
                draggingNode.ParentId = droppingNode.Id;
                draggingNode.__toUpdate = true;
            }
            _update();
        }
    }, [droppingNode]);

    const _toSave = () => {
        return data.filter(x => x.__toUpdate);
    }

    const _validate = () => {
        const errors = [];

        for (const d of data) {
            if (!d.Name) {
                var error = t("name_missing", { ns: "labels" }, { index: data.findIndex(x => x === d) + 1 })
                errors.push(error);
            }
        }

        return errors;
    }

    const _save = async () => {
        const errors = _validate();

        withReactContent(Swal).fire({
            title: t("saving", { ns: "labels" }),
            icon: "info",
            text: t("saving_data", { ns: "labels" }),
            allowOutsideClick: false
        });

        if (errors.length > 0) {
            withReactContent(Swal).fire({
                title: t("error", { ns: "labels" }),
                icon: "error",
                text: errors.join(','),
                showConfirmButton: true
            });
        }
        else {
            const dataToUpdate = _toSave();

            if (dataToUpdate.length == 0) {
                withReactContent(Swal).fire({
                    title: t("data_just_updated", { ns: "labels" }),
                    icon: "info",
                    text: t("no_changes_after_last_save", { ns: "labels" }),
                    showConfirmButton: true
                });
                return { success: false };
            }

            const result = await api.sendMessage("admin/requirements/save", {
                user: currentUser(),
                body: {
                    requirements: dataToUpdate
                }

            });

            if (result.success) {
                withReactContent(Swal).fire({
                    title: t("success", { ns: "labels" }),
                    icon: "success",
                    text: t("requirements_saved_with_success", { ns: "labels" }, { count: dataToUpdate.length }),
                    showConfirmButton: true
                });

                for (const d of data) {
                    d.__toUpdate = false;
                    setData(utils.clone(data));
                }

                return result;
            }
            else {
                withReactContent(Swal).fire({
                    title: "ERROR",
                    icon: "error",
                    text: result.message,
                    showConfirmButton: true
                });

                return result;
            }
        }

    }

    const _drawChangeMode = () => {
        if (viewMode == "list") {
            return (
                <a className="me-3 position-relative text-primary fs-13" href="#"
                    onClick={(e) => {
                        setViewMode("edit");
                    }}
                    title="go to edit mode">
                    <i class="fa-solid fa-pen-to-square fa-2x"></i>
                </a>)
        } else if (viewMode == "edit") {
            return (
                <a className="me-3 position-relative text-primary fs-13" href="#"
                    onClick={(e) => {
                        setViewMode("list");
                    }}
                    title="go to list mode">

                    <i class="fa-solid fa-list fa-2x"></i>
                </a>)
        }

        return (null)

    }

    const _drawViewModeContent = () => {

        if (viewMode == "list") {
            return _drawTabs()

        } else if (viewMode == "edit") {
            return (

                <table className="table">
                    <thead>
                        <tr>
                            <th className="col-md-1" scope="col">#</th>
                            <th className="col-md-9">{t("name", { ns: "labels" })}</th>
                            <th className="col-md-2">{t("action", { ns: "labels" })}</th>
                        </tr>
                    </thead>
                    <tbody id="tBodyTable">
                        {drawMainNode()}
                    </tbody>
                </table>)
        }
        return (null)

    }

    return (
        <>
            <div class="page-titles">
                <ol class="breadcrumb">
                </ol>
                <div>
                    {_drawChangeMode()}

                    <Undo_Redo onInit={(r) => {
                        undo_redo = r;
                    }}
                        onChange={(d) => {
                            setData(d);
                        }}
                    ></Undo_Redo>
                    <a class="text-primary fs-13" onClick={(e) => {
                        _save();
                    }} role="button" title="Save data"><i class="fa-solid fa-floppy-disk fa-2x"></i></a>
                </div>
            </div>

            <div style={{
                width: "100%",
                overflow: "scroll"

            }}>
            </div>

            <div className="container-fluid">
                <div className="row">
                    <div class="col-xl-12">
                        <div class="card">
                            <div class="card-body p-0">
                                <div class="tab-content" id="tabs-content" style={{ padding: 15 }}>
                                    {data ? (
                                        <>

                                            {_drawViewModeContent()}


                                            {editModal()}
                                        </>) : <div class="text-center"><img src={waiting} /></div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export { Requirements_Screen }